import { gEnums } from "../../enums/globalEnums"
import { responseReducers } from "./reducerHelpers/dispatchProps"
import _ from 'lodash'

const rts = {
  // handleElement_selected: 'handleElement_selected',
  handleParentElement_selected: 'handleParentElement_selected',
}

export const scrollableReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleParentElement_selected:
      return { ...state, selectedParentRef: action.selectedParentRef }

    // case rts.handleElement_selected:
    //   return { ...state, selectedElemRef: action.selectedElemRef }

    default:
      return { ...state }
  }
}

export const scrollableInitialState = (initState) => {
  return { ...initState }
};

export const scrollableHandlers = (dispatch) => {
  return {
    // handleElement_selected: (selectedElemRef) => { dispatch({ type: rts.handleElement_selected, selectedElemRef }) },
    handleParentElement_selected: (selectedParentRef) => { dispatch({ type: rts.handleParentElement_selected, selectedParentRef }) },
  }
}
